import type { BadgeColor, BadgeMode } from '@enamelai/design-system'
import { useTheme } from '@context/ThemeContext'

/** Tinted badges on light surfaces, solid badges on dark surfaces. */
export const useInsuranceBadgeMode = (): BadgeMode => {
  const { resolvedTheme } = useTheme()
  return resolvedTheme === 'dark' ? 'solid' : 'tinted'
}

export const getInsurancePlanStatusColor = (status: string): BadgeColor =>
  status === 'Active' ? 'vivid-green' : 'red'

const CLAIM_STATUS_COLOR: Record<string, BadgeColor> = {
  Approved: 'vivid-green',
  'Partially Approved': 'pale-green',
  Rejected: 'red',
  Denied: 'red',
  'Under Review': 'yellow',
  Draft: 'blue',
  Pending: 'gray',
}

export const getClaimStatusColor = (status: string): BadgeColor =>
  CLAIM_STATUS_COLOR[status] ?? 'gray'
